import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { SvgIconComponent, injectRegisterIcons } from '@ngneat/svg-icon';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';

import { isProduction } from '@core/helpers/is-production';
import { loadRecentConversations, openPanel, selectConversation, setPanelSize } from '@core/stores/ai-assistant/ai-assistant.actions';
import { selectIsPanelOpen, selectRecentConversationListVm } from '@core/stores/ai-assistant/ai-assistant.selectors';
import { selectTenantHasFeatureFlag, selectUserHasEitherPermissions } from '@core/stores/auth/auth.selectors';

import { PermissionStoreModelEnum } from '@domain/permissions/permissions.enums';
import { FeatureFlags } from '@domain/tenant/tenant.enums';

import { UpPipe } from '@shared/pipes/up/up.pipe';

import { appAi24Icon } from '@icons/ai-24';
import { appArrowLink16Icon } from '@icons/arrow-link-16';

@Component({
  selector: 'app-ai-assistant-banner',
  imports: [NgClass, SvgIconComponent, TranslatePipe, UpPipe],
  templateUrl: './ai-assistant-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col' },
})
export class AiAssistantBannerComponent implements OnInit {
  readonly #store = inject(Store);

  public readonly production = isProduction();

  public readonly hasAiPermission = this.#store.selectSignal(
    selectUserHasEitherPermissions([
      PermissionStoreModelEnum.ViewAnySiteWithAiAssistant,
      PermissionStoreModelEnum.ViewOwnSiteWithAiAssistant,
    ])
  );
  public readonly hasAiAssistantEnabled = this.#store.selectSignal(selectTenantHasFeatureFlag(FeatureFlags.AiAssistant));
  public readonly isPanelOpen = this.#store.selectSignal(selectIsPanelOpen);
  public readonly recentConversations = this.#store.selectSignal(selectRecentConversationListVm);

  constructor() {
    injectRegisterIcons([appAi24Icon, appArrowLink16Icon]);
  }

  public ngOnInit(): void {
    if (this.hasAiPermission() && this.hasAiAssistantEnabled()) {
      this.#store.dispatch(loadRecentConversations());
    }
  }

  public onAskAiClick(): void {
    this.#store.dispatch(openPanel({ size: 'small' }));
  }

  public onRecentConversationClick(conversationId: string): void {
    this.#store.dispatch(selectConversation({ conversationId }));
    this.#store.dispatch(setPanelSize({ size: 'small' }));
  }
}
